import { createSlice } from '@reduxjs/toolkit';
import { OrdersGridStateType } from 'src/types/ordersGrid';

const initialState: OrdersGridStateType = {
    data: null,
    allProviders: false,
    archive: false,
    loading: false,
    error: false,
};
export const ordersGridSlice = createSlice({
    name: 'ordersGrid',
    initialState,
    reducers: {
        getOrdersGridFetch: (state, action) => {
            state.loading = true;
            state.error = false;
            if (action.payload) {
                state.allProviders = action.payload.allProviders;
                state.archive = !!action.payload.archive;
            }
        },
        getOrdersGridFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getOrdersGridFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const { getOrdersGridFetch, getOrdersGridFetchSuccess, getOrdersGridFetchFailure } = ordersGridSlice.actions;

export default ordersGridSlice.reducer;
